import { PersistQueryClientProvider } from '@tanstack/react-query-persist-client';
import { Suspense } from 'react';
import { Redirect, Route, Switch } from 'wouter';
import { DisplayApp } from '@/display/DisplayApp';
import { lazyWithReload } from '@/lib/lazyWithReload';
import { CACHE_VERSION, persister, queryClient, shouldPersist } from '@/queries/client';

// The companion is phone-only; keep it out of the iPad's initial bundle.
const CompanionApp = lazyWithReload(() => import('@/companion/CompanionApp'));

export function App() {
  return (
    <PersistQueryClientProvider
      client={queryClient}
      persistOptions={{ persister, maxAge: 24 * 60 * 60 * 1000, buster: CACHE_VERSION, dehydrateOptions: { shouldDehydrateQuery: shouldPersist } }}
      onSuccess={() => queryClient.resumePausedMutations()}
    >
      <Switch>
        <Route path="/display/*?">
          <DisplayApp />
        </Route>
        <Route path="/app/*?">
          <Suspense fallback={null}>
            <CompanionApp />
          </Suspense>
        </Route>
        <Route>
          <Redirect to="/display" />
        </Route>
      </Switch>
    </PersistQueryClientProvider>
  );
}
